export default "__VITE_ASSET__877ab2c3__"